/**
 *  Wrap useVirtualizer hook & add endless scroll logic
 */

import { useEffect } from 'react'
import {
  useVirtualizer,
  VirtualItem,
  Virtualizer as _Virtualizer,
} from '@tanstack/react-virtual'

export type Virtualizer = _Virtualizer<Element, Element>
export type { VirtualItem }

type ReactVirtualOptions = Parameters<typeof useVirtualizer>[0]

interface Options extends ReactVirtualOptions {
  onNearEnd?: () => void
  nearEndOffset?: number
}

export const useVirtual = ({
  onNearEnd,
  nearEndOffset = 5,
  ...options
}: Options): Virtualizer => {
  const rowVirtualizer = useVirtualizer(options)

  const virtualItems = rowVirtualizer.getVirtualItems()

  // Endless scroll
  useEffect(() => {
    const lastItem = virtualItems[virtualItems.length - 1]

    if (!lastItem) return

    if (lastItem.index >= options.count - nearEndOffset) {
      onNearEnd?.()
    }
  }, [onNearEnd, options.count, nearEndOffset, virtualItems])

  return rowVirtualizer
}
